const sizeConfigs = {
  sidebar: {
    width: "330px"
  }
};

export default sizeConfigs;